import { useListInvoicedocumentsQuery } from 'store/invoices/invoices.api'

import { InvoiceResponse } from 'store/invoices/invoices.types'
import { skipToken } from '@reduxjs/toolkit/query'
import InvoiceDocumentsTable from '../../invoice-table-documents/invoice-documents-dialog/invoice-documents-table/invoice-documents-table.component'

interface IProps {
  invoice: InvoiceResponse
}

const InvoiceEmailAttachments = ({ invoice }: IProps) => {
  const { data: documents } = useListInvoicedocumentsQuery({
    orderId: invoice?.orderId ?? skipToken,
  })

  if (!documents) {
    return <p>loading</p>
  }

  return (
    <InvoiceDocumentsTable
      documents={documents}
      orderId={invoice?.orderId}
      invoiceId={invoice?.id}
      companyId={invoice?.customerId}
      condensed
    />
  )
}

export default InvoiceEmailAttachments
